export default __webpack_public_path__ + "static/media/h.ceddf60f.wav";